import React, { Component } from 'react';
import { Grid, Typography, Paper, Tabs, Tab, Box } from '@material-ui/core';
import { HomeSupplierProps } from '../../connected/HomeSupplierCnn'
import { withRouter } from 'react-router';
import LogoAndTitle from '../../../Layout/components/LogoAndTitle';
import { SupplierMappingsCnn } from '../../../Supplier/connected/SupplierMappingsCnn';
import { SupplierDeliveriesCnn } from '../../../Supplier/connected/SupplierDeliveriesCnn';
import { TabPanel } from '../../../Common/TabPanel';
import SupplierPaymentDetails from '../../../Supplier/components/SupplierPaymentDetails';
import SupplierOrders from '../../../Supplier/components/SupplierOrders';
import { SupplierOrdersCnn } from '../../../Supplier/connected/SupplierOrdersCnn';

type State = {
    currentTab: number
}

class HomeSupplier extends Component<HomeSupplierProps, State> {
    constructor(props: HomeSupplierProps) {
        super(props);

        this.state = {
            currentTab: 0
        }
    }

    componentWillMount() {
        if (this.props.supplierInfo === null && this.props.getSupplierInfoBusy !== true)
            this.props.getSupplierInfo()
    }


    render() {
        return (
            <Grid container>
                <Grid item sm={12} >
                    <LogoAndTitle title="Welcome to QMO!" />
                    {this.props.supplierInfo &&
                        < Paper style={{ padding: '15px' }}>
                            <Tabs
                                value={this.state.currentTab}
                                indicatorColor="primary"
                                textColor="primary"
                                onChange={(e, v) => this.setState({ currentTab: v })}
                                aria-label="disabled tabs example"
                            >
                                <Tab label="Orders">
                                </Tab>
                                <Tab label="Manage Deliveries">
                                </Tab>
                                <Tab label="Manage Products & Mappings">
                                </Tab>
                                <Tab label="Manage Payment Details">
                                </Tab>
                            </Tabs>

                            
                            <TabPanel value={this.state.currentTab} index={0}>
                                <SupplierOrdersCnn />
                            </TabPanel>
                            <TabPanel value={this.state.currentTab} index={1}>
                                <SupplierDeliveriesCnn />
                            </TabPanel>
                            <TabPanel value={this.state.currentTab} index={2}>
                                <SupplierMappingsCnn />
                            </TabPanel>
                            <TabPanel value={this.state.currentTab} index={3}>
                                <SupplierPaymentDetails />
                            </TabPanel>
                        </Paper>
                    }
                </Grid>
            </Grid >
        );
    }
}

export default withRouter(HomeSupplier);